import PropTypes from 'prop-types';
import styled, { keyframes } from 'styled-components';

import type { CommonProps } from './constants';
import { COMMON } from './constants';
import theme from './theme';

type Props = CommonProps;

const animatePulse = keyframes`
  0% {
    opacity: 1;
  }
  60% {
    opacity: 0.5;
  }
  100% {
    opacity: 1;
  }
`;

const AnimatePulse = styled.div<Props>`
  animation-name: ${animatePulse};
  animation-duration: 2s;
  animation-iteration-count: infinite;
  ${COMMON};
`;

AnimatePulse.defaultProps = { theme };

AnimatePulse.propTypes = {
  ...COMMON.propTypes,
  theme: PropTypes.object, // eslint-disable-line react/forbid-prop-types
};

AnimatePulse.displayName = 'AnimatePulse';

export { AnimatePulse };
